import { required, optional } from 'AppReact/schema';

export default {
  tenant_id: required('integer'),
  name: required('string'),
  applicant_id: optional('integer'),
  is_incoming: optional('boolean'),
  is_current: optional('boolean')
};
